<app-bread-crumb [Locations]="breadcrumbLocations" [current]="siteDetails?.SiteName ?? ''">
</app-bread-crumb>

<app-site-details-banner [siteDetails]="siteDetails"></app-site-details-banner>

<div class="nsw-container" style="margin-top : 2rem;">        
    <div class="nsw-layout">
        <main class="nsw-layout__main" >
            <h2>Water quality forecast and ratings</h2>
            <div class="gap-between left-container">
                <app-water-quality-forecast *ngIf="siteDetails?.PollutionForecast" 
                    [pollutionForecast]="siteDetails?.PollutionForecast || ''"
                    [pollutionForecastDate]="siteDetails?.PollForecastDt" 
                    [pollutionDescription]="siteDetails?.PollutionDescription || ''"
                    [patrolDescription]="siteDetails?.PatrolDescription || ''">
                </app-water-quality-forecast>  
            </div>
            
            <ng-container *ngFor="let siteAlert of siteDetails?.Alerts"> 
                <div class="gap-between left-container">
                    <app-site-alert [title]="siteAlert.Type" [description]="siteAlert.Text" [target]="siteAlert.Url" 
                        [lastUpdatedDt]="siteAlert?.LastUpdated ?? ''"></app-site-alert>                                
                </div>                        
            </ng-container>                 

            <section class="nsw-section nsw-section--box gap-between left-container" style="width:100%;" *ngIf="siteDetails?.ShowWaterTemp">                   
                <div class="nsw-container-fluid">
                    <div class="nsw-grid nsw-grid--spaced">
                        <div class="nsw-col nsw-col-md nsw-col-lg-4" style="padding-bottom:0;">
                            <h3>Water temperature</h3>                              
                        </div>
                        <div class="nsw-col nsw-col-md nsw-col-lg-8" style="padding-bottom:0;">
                            <h2 *ngIf="siteDetails?.WaterTemp">{{siteDetails?.WaterTemp}} °C</h2>
                        </div>
                    </div>
                    <div class="nsw-grid nsw-grid--spaced">
                        <div class="nsw-col nsw-col-md nsw-col-lg-4" style="padding-top : 8px;padding-bottom:0;">   
                            <div>
                                <app-last-updated-widget 
                                    [label]="'Last updated'"
                                    [updatedDate]="siteDetails?.PollForecastDt"
                                    dateOutFormat="dd/MM/YY">
                                </app-last-updated-widget>
                            </div>                                
                        </div>
                        <div class="nsw-col nsw-col-md nsw-col-lg-8" style="padding-bottom:0;">
                            <span class="water-quality-card-description">Measured daily using satellite technology</span>
                        </div>
                    </div>
                </div>                    
            </section>

            <section class="nsw-section nsw-section--box gap-between left-container" style="width:100%;">
                <app-tabs>
                    <app-tab label="Latest result" [active]="true">
                        <div class="nsw-grid">
                            <div class="nsw-col nsw-col-lg-4">                              
                                <div class="latest-result-left-frame">
                                    <app-last-updated-widget 
                                        [label]="'Last tested'" 
                                        [updatedDate]="siteDetails?.LatestResultDt" 
                                        dateOutFormat="dd/MM/YY">
                                    </app-last-updated-widget> 
                                    <app-site-rating 
                                        *ngIf="siteDetails?.LatestResultStarRating"
                                        [rating]="siteDetails?.LatestResultStarRating"
                                        [useBlueIcons]="true">
                                    </app-site-rating> 
                                </div>                              
                            </div>
                            <div class="nsw-col nsw-col-lg-1">                              
                                <div class="latest-result-divider"></div>                       
                            </div>
                            <div class="nsw-col nsw-col-lg-7">                            
                                <div class="latest-result-right-frame">
                                    <p>Latest result is generated for each swim site based on a single enterococci data point from the most recent sampling date.</p>
                                    <app-key-popup-widget description="Key for latest results" popupTitle="Key for latest results" keyupdates >
                                        <app-key-latest-result-popup-content-widget></app-key-latest-result-popup-content-widget>
                                    </app-key-popup-widget>
                                </div>                              
                            </div>
                        </div>

                    </app-tab>

                    <app-tab label="Annual grade" [active]="false"> 
                        <div class="nsw-grid">
                            <div class="nsw-col nsw-col-lg-4">                              
                                <div class="latest-result-left-frame">                                 
                                    <app-annual-grade class="annual-grade-component-width" 
                                        [annualGrade]="siteDetails?.AnnualGrade ?? ''"
                                        description="">
                                    </app-annual-grade>
                                </div>                              
                            </div>
                            <div class="nsw-col nsw-col-lg-1">                              
                                <div class="latest-result-divider"></div>                       
                            </div>
                            <div class="nsw-col nsw-col-lg-7">                            
                                <div class="latest-result-right-frame">
                                    <p>Annual grade is reported at the start of the summer each year.</p>
                                    <app-key-popup-widget description="Key for annual grade" popupTitle="Key for Annual grade" keyupdates >
                                        <app-key-annual-grade-popup-content-widget></app-key-annual-grade-popup-content-widget>
                                    </app-key-popup-widget>
                                </div>                              
                            </div>
                        </div>
                    </app-tab>
                </app-tabs>
            </section>

        </main>

        <div class="nsw-layout__sidebar" style="height: fit-content;" *ngIf="!!siteDetails?.ShowSubscription">
            <div class="nsw-card nsw-card--headline">
                <div class="nsw-card__content sidebar-card-content">
                    <div class="nsw-card__title">
                        <a href="#" routerLink="/userSubscriptions" [queryParams]="{ siteIdentifier : siteDetails?.Identifier ?? '' }">
                            Subscribe for updates to {{siteDetails?.SiteName ?? ""}}
                        </a>
                    </div>
                    <div class="nsw-card__copy">
                        <p> Get daily forecasts delivered to your inbox, for this swim site and as many others as you want.
                        </p>
                    </div>
                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="nsw-container">        
    <div class="nsw-layout">
        <main class="nsw-layout__main" >
            <section class="nsw-section gap-between left-container" style="width:100%;"> 
                <app-forecast-widget [siteDetails]="siteDetails"></app-forecast-widget>
            </section> 
            <section class="nsw-section" style="width:100%;"> 
                <app-about-site 
                    [siteName]="siteDetails?.SiteName ?? ''" 
                    [siteDescription]="siteDetails?.Description ?? ''" 
                    [patrolDescription]="siteDetails?.PatrolDescription ?? ''"
                    [siteAmenities]="siteDetails?.Amenities ?? []">
                </app-about-site>
            </section>               
        </main>
        <div class="nsw-layout__sidebar">

        </div>
    </div>
</div>

<div class="nsw-container" *ngIf="canDisplayDivider()"> 
    <div class="divider"></div>
</div>

<div class="nsw-container" >
    <div class="nsw-layout">
        <main class="nsw-layout__main"  style="width : 100%;">
            <ng-container *ngIf="canDisplayTrendSection(trendTypes.Enterococci)">
                <section class="nsw-section" style="width:100%;">                                        
                    <app-site-trends 
                        [siteName]="siteDetails?.SiteName ?? ''"
                        [enterococciTrends]="siteEnterococciTrends"
                        [siteId]="siteDetails?.Identifier ?? ''"
                        [monitoringDetails]="siteDetails?.MonitoringDetails ?? []">
                    </app-site-trends>
                </section>
            </ng-container>

            <ng-container *ngIf="canDisplayTrendSection(trendTypes.Rainfall)">
                <section class="nsw-section" style="width:100%;">                        
                    <app-site-rainfall-statistics 
                        [rainGaugeName]="siteDetails?.RainGaugeName ?? ''"
                        [siteRainfallTrends]="siteRainfallTrends" 
                        [siteName]="siteDetails?.SiteName ?? ''"
                        [siteId]="siteDetails?.Identifier ?? ''">
                    </app-site-rainfall-statistics>
                </section>
            </ng-container>
            
            <ng-container *ngIf="!!siteDetails?.ShowWaterTemp && canDisplayTrendSection(trendTypes.WaterTemp)">            
                <section class="nsw-section" style="width:100%;">                        
                    <app-site-water-temperature-statistics 
                        [watertempTrends]="siteWatertempTrends"
                        [siteName]="siteDetails?.SiteName ?? ''"
                        [siteId]="siteDetails?.Identifier ?? ''">
                    </app-site-water-temperature-statistics>
                </section>                    
            </ng-container>

            <ng-container *ngIf="canDisplayTrendSection(trendTypes.AnnualGrade)">
                <section class="nsw-section" style="width:100%;">                  
                    <app-site-annual-grade-statistics
                        [annualgradeTrends]="siteAnnualgradeTrends"
                        [siteName]="siteDetails?.SiteName ?? ''"
                        [siteId]="siteDetails?.Identifier ?? ''">
                    </app-site-annual-grade-statistics>
                </section>
            </ng-container>
        </main>
    </div>
</div>

<div class="nsw-container" > 
    <h2>Nearby monitored swim sites</h2>
    
    <!-- <div class="nsw-h3" *ngIf="0 === siteDetails?.NearbySites?.length!">There are no nearby monitored swim sites.</div> -->
    <h3 *ngIf="0 === siteDetails?.NearbySites?.length!" class="nsw-m-bottom-md">There are no nearby monitored swim sites.</h3>

    <div class="nsw-grid nearby-sites-section" *ngIf="0 < siteDetails?.NearbySites?.length!">
        <ng-container *ngFor="let nearbySite of siteDetails?.NearbySites ?? []">
            <div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
                <app-nearby-site-widget [siteName]="nearbySite?.SiteName" [distanceM]="nearbySite.DistanceM"
                    [identifier]="nearbySite.Identifier" [sitePhoto]="nearbySite.SitePhoto">
                </app-nearby-site-widget>
            </div>
        </ng-container>            
    </div>
</div>

